module.exports = __webpack_public_path__ + "static/media/sample4@2x.26b27ccc.jpg";